import addDays from 'date-fns/addDays';

export const cookieParams = {
  sameSite: `lax`,
  path: `/`,
  expires: addDays(new Date(), 30),
};
